if (!customElements.get('grid-badges')) {
  function arrayIntersection(array1, array2) {
    return array1.filter((value) => array2.includes(value))
  }

  customElements.define(
    'grid-badges',
    class Badges extends HTMLElement {
      constructor() {
        super()
        this.tags = this.dataset.tags.split(',')
        this.initBadges()
      }

      buildStyles(tag) {
        return `style = "padding-left: 2px; padding-top: 1px; background-color: ${tag.backgroundColor}; color: ${tag.textColor}; border: 1px solid ${tag.borderColor == '' ? 'transparent' : tag.borderColor}"`
      }

      addSoldOutTag(available) {
        if (typeof available === 'undefined') return
        const boolAvailable = available === 'true'
        if (!boolAvailable) {
          this.tags.push(window.badges.config.soldOutDummyTag)
        }
      }

      initBadges() {
        if (!window.badges) return
        var positions = {
          'top-left': [],
          'top-right': [],
          'bottom-left': [],
          'bottom-right': []
        }

        for (const badge of window.badges.list) {
          if (badge.tags.length && arrayIntersection(this.tags, badge.tags)?.length == badge.tags.length) {
            if (badge.exclusionTags.length && arrayIntersection(this.tags, badge.exclusionTags)?.length > 0) {
              continue
            }
            let html = `<span ${this.buildStyles(badge)} class="card__badge subtitle ${badge.backgroundColor ? 'hide--dot' : ''}">
              ${badge.text}
            </span>`
            positions[badge.position].push(html)
          }
        }
        let badgesHtml = ''
        for (const pos in positions) {
          if (positions[pos].length) {
            badgesHtml = badgesHtml + `<div class="badges badges--${pos}">${positions[pos].join('')} </div>`
          }
        }
        this.innerHTML = badgesHtml
      }
    }
  )
}
